import { MotifIcon } from '@ey-xd/motif-react'
import WorkspaceStatus from '../atoms/WorkspaceStatus'
import iconSvg from "../../assets/icons/icon.svg.json";
import AppTable from '../atoms/AppTable';
import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';

const UsersListTable = (props: any) => {
    const { tableData } = props;
    const navigate = useNavigate();
    const { access } = useSelector((state: any) => state.user);

    const columns = [
        { header: 'S.No.', accessor: 'serial', 
            render: (data) => (
                <p>
                    {tableData.findIndex(item => item.id === data.id) + 1}
                </p>
            )
        },
        { header: 'Name', accessor: 'name' },
        { header: 'User group', accessor: 'groupRelation',
            render: (data) => (
                <p>
                    {data.groupRelation && data.groupRelation.length > 0 ? data.groupRelation[0].group.groupName : ''}
                </p>
            )
         },
        { header: 'Role', accessor: 'roleName' },
        { header: 'Status', accessor: 'userStatus',
            render: (data) => (
                <WorkspaceStatus status={data?.userStatus} />
            )
         },
        {
          header: 'Action',
          accessor: 'action',
          render: (data) => (
            // <>
            <MotifIcon title={access.write === false ? "Write access denied" : ""} onClick={() => {
                if(access.write === false) {
                    alert("Write access denied")
                    return;
                }
                navigate(`/admin/users/edit/${data?.id}`, {state: data})
            }} src={iconSvg["edit-icon"]} className="!w-6 cursor-pointer" />
            // </>
          ),
        },
      ];

    return (
        <AppTable columns={columns} tableData={tableData} />
    )
}

export default UsersListTable